import { render, staticRenderFns } from "./ShopMallAddressList.vue?vue&type=template&id=35580004&scoped=true&"
import script from "./ShopMallAddressList.vue?vue&type=script&lang=js&"
export * from "./ShopMallAddressList.vue?vue&type=script&lang=js&"
import style0 from "./ShopMallAddressList.vue?vue&type=style&index=0&id=35580004&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35580004",
  null
  
)

export default component.exports